module.exports = __webpack_public_path__ + "img/NO.d91702a1.svg";